<template>
	<v-dialog
		v-if="!standalone"
		v-model="dialog"
		class="raw-data-viewer"
		transition="dialog-bottom-transition"
		z-index="2000"
		fullscreen
	>
		<v-raw-data-viewer-data
			v-model="dialog"
			:raw-data="rawData"
			:file-names="fileNames"
			:module-window="moduleWindow"
			:standalone="standalone"
			@update-json="updateJson"
			@reload-data="reloadData"
		/>
	</v-dialog>

	<div
		v-else
		class="raw-data-viewer-standalone"
		style="
			position: fixed;
			top: 0;
			left: 0;
			width: 100vw;
			height: 100vh;
			z-index: 2000;
			background: white;
			overflow-y: auto;
		"
	>
		<v-raw-data-viewer-data
			v-model="dialog"
			:raw-data="rawData"
			:file-names="fileNames"
			:module-window="moduleWindow"
			:standalone="standalone"
			@update-json="updateJson"
			@reload-data="reloadData"
		/>
	</div>
</template>

<script>
import VRawDataViewerData from "@/pages/RawDataViewer/VRawDataViewerData.vue";

export default {
	name: "VRawDataViewer",

	components: {
		VRawDataViewerData,
	},

	props: {
		modelValue: {
			type: Boolean,
			required: true,
			default: false,
		},
		rawData: {
			type: Object,
			required: true,
			default: () => ({}),
		},
		fileNames: {
			type: Array,
			required: true,
			default: () => [],
		},
		moduleWindow: {
			type: Object,
			required: false,
			default: null,
		},
		standalone: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	emits: ["update:modelValue", "updateJson", "reload-data"],

	computed: {
		dialog: {
			get() {
				return this.modelValue;
			},
			set(newValue) {
				this.$emit("update:modelValue", newValue);
			},
		},
	},

	methods: {
		updateJson(json) {
			this.$emit("updateJson", json);
		},
		reloadData() {
			this.$emit("reload-data");
		},
	},
};
</script>

<style lang="scss">
.raw-data-viewer {
	.raw-data-table {
		th {
			font-weight: bold !important;
		}

		.v-table__wrapper {
			max-height: 500px;
		}
	}

	.json-editor textarea {
		font-family: "Fira Code", monospace;
		height: 80vh;
	}
}
</style>
